import { useFlashListContext } from '@shopify/flash-list';

export const useItemLayout = (index: number) => {
  const context = useFlashListContext();
  const ref = context?.getRef();

  return ref?.getLayout(index);
};
